<template>
	<article class="layout-3-col-wrapper">
			<div class="left"></div>
			<div :class="`middle ${shelfComponent && 'hidden-sm '}`">
					<div v-if="selectedItemStatus.loading" >
						<spinner></spinner>
					</div>

					<div v-if="!selectedItemStatus.loading && selectedItem && selectedItem.state === 'AVAILABLE'" class="details-content">
						<router-link :to="{name: 'marketplace'}" class="arrow-link" >
							<i class="fas fa-chevron-left"></i>
							<span>Browse All Integrations</span>
						</router-link>
						<header>
							<div class="item-logo">
								<img v-bind:src="selectedItem.logo">
							</div>
							<div class="header-title"><div>{{selectedItem.name}} <span class="hidden-sm credits"> Uses {{ selectedItem.getCostLabel() }} Credits </span></div>
								<span class="visible-sm visible-xs credits"> Uses {{ selectedItem.getCostLabel() }} Credits </span>
								<div>
									<button v-if="selectedItem.appId && app && app.strategy && !appIdentity" type="button" :class="`${!shelfComponent &&  'call-to-action' } outline-btn`" @click="auth()" :disabled="appAuthorizationStatus.loading">Authorize<spinner v-if="appAuthorizationStatus.loading" hideText="true"></spinner></button>
									<button v-else type="button" :class="`${!shelfComponent &&  'call-to-action' } outline-btn`"  @click="toggleInstallShelf()">{{ shelfComponent ? 'Quit Setup' : 'Begin Setup'}}</button>
								</div>
							</div>
						</header>

						<section v-if="selectedItem.description" class="section-description">
							<p>{{selectedItem.description}}</p>
						</section>
						<section style="padding-top:20px; padding-bottom:20px;">
							<div class="section-body row" style="align-items: center;">
								<svg width="30px" height="30px" style="vertical-align: middle; margin-right:5px;" viewBox="0 0 82 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
										<path d="M30.7,0.9 C30.1,0.5 29.2,0.8 28.9,1.4 L28,2.9 C27.6,3.5 27.9,4.4 28.5,4.7 C28.5,4.7 28.9,4.9 29.4,5.2 C29.9,5.5 29.7,5.8 29,6.1 C12.3,11.2 0.3,26.7 0.3,45 C0.3,64.5 14.1,80.9 32.5,84.8 C33.2,85 33.8,84.5 33.8,83.7 L33.8,81 C33.8,80.3 33.2,79.5 32.5,79.4 C17,75.5 5.6,61.6 5.6,45 C5.6,29.2 16,15.9 30.3,11.3 C31,11.1 31.4,11.3 31.1,11.7 L30.7,12.5 C30.3,13.1 30.6,14 31.2,14.3 L32.7,15.2 C33.3,15.6 34.2,15.3 34.5,14.7 L37.3,9.8 C37.7,9.2 38.1,8.3 38.4,7.9 C38.6,7.5 38.8,7.1 38.8,7.1 C39.2,6.5 38.9,5.6 38.3,5.3 L30.7,0.9 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
										<path d="M71.3,72.2 C72,71.4 72.6,70.7 73.3,69.9 C74,69.1 74.5,68.2 75.1,67.4 C75.1,67.3 75.2,67.3 75.2,67.2 C75.7,66.4 76.2,65.5 76.7,64.7 C76.8,64.6 76.8,64.5 76.9,64.4 C77.4,63.6 77.8,62.7 78.2,61.8 C78.3,61.7 78.3,61.5 78.4,61.4 C78.8,60.5 79.1,59.6 79.5,58.7 C79.6,58.5 79.6,58.4 79.7,58.2 C80,57.3 80.3,56.4 80.5,55.4 C80.5,55.3 80.6,55.1 80.6,54.9 C80.8,53.9 81.1,53 81.2,52 C81.2,51.9 81.2,51.7 81.3,51.6 C81.5,50.6 81.6,49.6 81.7,48.5 C81.7,48.4 81.7,48.3 81.7,48.2 C81.8,47.1 81.8,46 81.8,44.9 C81.8,43.6 81.7,42.4 81.6,41.2 C80,23.3 66.8,8.8 49.6,5.1 C48.9,4.9 48.3,5.4 48.3,6.2 C48.3,7 48.3,8.1 48.3,9 C48.3,9.7 48.9,10.5 49.6,10.6 C52,11.2 54.2,12 56.4,13.1 C56.6,13.2 56.7,13.2 56.9,13.3 C57.2,13.4 57.4,13.6 57.6,13.7 C68.7,19.7 76.4,31.5 76.4,45 C76.4,46 76.4,47.1 76.3,48.1 C76.3,48.5 76.2,48.8 76.2,49.2 C76.1,49.9 76.1,50.5 75.9,51.2 C75.8,51.6 75.7,52 75.6,52.5 C75.5,53.1 75.4,53.6 75.2,54.2 C75.1,54.7 74.9,55.1 74.8,55.5 C74.6,56 74.5,56.5 74.3,57 C74.1,57.5 73.9,57.9 73.7,58.4 C73.5,58.8 73.4,59.3 73.2,59.7 C73,60.2 72.7,60.7 72.5,61.1 C72.3,61.5 72.1,61.9 71.9,62.2 C71.6,62.7 71.3,63.2 71,63.7 C70.8,64 70.6,64.4 70.4,64.7 C70.1,65.2 69.7,65.7 69.4,66.2 C69.2,66.5 69,66.8 68.8,67 C68.4,67.5 68,68 67.6,68.5 C67.4,68.7 67.2,69 67,69.2 C66.5,69.7 66.1,70.2 65.6,70.6 C65.4,70.8 65.2,71 65,71.2 C64.5,71.7 63.9,72.1 63.4,72.6 C63.2,72.7 63,72.9 62.9,73 C62.3,73.5 61.7,73.9 61.1,74.3 C60.9,74.4 60.8,74.5 60.6,74.6 C60,75 59.3,75.4 58.6,75.8 C58.5,75.9 58.3,75.9 58.2,76 C57.5,76.4 56.8,76.8 56,77.1 C55.9,77.1 55.8,77.2 55.7,77.2 C54.9,77.6 54.1,77.9 53.3,78.2 C53.2,78.2 53.2,78.2 53.1,78.3 C52.2,78.6 51.4,78.9 50.5,79.1 C50.5,79.1 51.4,77.5 51.4,77.5 C51.8,76.9 51.5,76 50.9,75.7 L49.4,74.8 C48.8,74.4 47.9,74.7 47.6,75.3 L44.2,81.4 C44.2,81.4 43.3,82.9 43.3,82.9 C42.9,83.5 43.2,84.4 43.8,84.7 L51.4,89 C52,89.4 52.9,89.1 53.2,88.5 L54.1,87 C54.5,86.4 54.2,85.5 53.6,85.2 C53.6,85.2 53.2,85 52.7,84.7 C52.2,84.4 51.9,84.2 51.9,84.2 C51.9,84.2 51.9,84.2 51.9,84.2 C52.9,83.9 53.9,83.6 54.8,83.3 C54.9,83.3 55,83.2 55.1,83.2 C56,82.9 57,82.5 57.9,82.1 C58,82 58.1,82 58.3,81.9 C59.2,81.5 60,81.1 60.9,80.6 C61,80.5 61.2,80.4 61.3,80.4 C62.1,79.9 62.9,79.4 63.7,78.9 C63.8,78.8 64,78.7 64.1,78.6 C64.9,78.1 65.6,77.5 66.4,76.9 C66.5,76.8 66.6,76.7 66.8,76.6 C67.5,76 68.3,75.4 68.9,74.7 C69,74.6 69.1,74.5 69.2,74.4 C69.9,73.7 70.6,73 71.2,72.3 C71.1,72.4 71.2,72.3 71.3,72.2 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
										<circle id="Oval" fill="#000000" fill-rule="nonzero" cx="41.4" cy="20.8" r="3"></circle>
										<circle id="Oval" fill="#000000" fill-rule="nonzero" cx="65.4" cy="44.9" r="3"></circle>
										<circle id="Oval" fill="#000000" fill-rule="nonzero" cx="41.4" cy="69.2" r="3"></circle>
										<circle id="Oval" fill="#000000" fill-rule="nonzero" cx="16.6" cy="44.9" r="3"></circle>
										<path d="M59.1,59.8 L47,47.6 C47.4,46.8 47.6,45.9 47.6,44.9 C47.6,42.2 45.8,39.8 43.4,39 L43.3,30.4 C43.3,29.3 42.4,28.4 41.3,28.4 C41.3,28.4 41.3,28.4 41.3,28.4 C40.2,28.4 39.3,29.3 39.3,30.5 L39.4,39.1 C37,40 35.3,42.2 35.3,44.9 C35.3,48.3 38.1,51.1 41.5,51.1 C42.5,51.1 43.4,50.9 44.2,50.5 L56.3,62.6 C56.7,63 57.2,63.2 57.8,63.2 C58.3,63.2 58.8,63 59.2,62.6 C59.9,61.9 59.9,60.6 59.1,59.8 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
									</g>
								</svg>
								<div>
									<span class="readable-frequency">New data <span class="cronReadable">{{selectedItem.cronReadable()}}</span> when you apply {{selectedItem.getCostLabel(true)}} credit(s) during setup.</span>
									<TipLink v-if="selectedItem.cronSelections && selectedItem.cronSelections.length > 1" linkText="Options Available">
										<p>
											During setup, you can choose how often this integration will run for different credit amounts.
										</p>
										<p>
											Want to change this interval later to free up some credits? No problem.
											Just choose the lower interval and your applied credits will be available again
											to use for something else.
										</p>
										<p>
											Your subscription includes 10 credits.
										</p>
									</TipLink>
								</div>
							</div>
						</section>
						<section v-if="!selectedItemStatus.loading && selectedItem && selectedItem.state === 'AVAILABLE'">
							<AuthAppDetails :app="app" :appIdentity="appIdentity"></AuthAppDetails>
							<Details :item="selectedItem"></Details>
						</section>
					</div>
			</div>
			<div class="right">
				<component v-bind:is="shelfComponent" @close="onCloseInstallShelf" v-bind="shelfProps"></component>
			</div>

			<auth-app-modal/>
	</article>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Spinner from '../components/Spinner';
	import SettingExpand from '../components/SettingExpand';
	import ItemInstall from '../components/ItemInstall.vue';
	import AuthAppModal from '../components/AuthAppModal.vue';
	import Details from '../components/Details.vue';
	import AuthAppDetails from '../components/AuthAppDetails.vue';
	import TipLink from '../components/TipLink.vue';

	export default {
		name: 'MarketplaceItem',
		filters: {},
		data(){
			return {
				showInstall: false,
				shelfComponent: null,
				shelfProps: null,
			};
		},
		components: {
			SettingExpand,
			Spinner,
			AuthAppModal,
			ItemInstall,
			Details,
			AuthAppDetails,
			TipLink
		},
		computed: {
			...mapGetters([
				'selectedItem',
				'selectedItemStatus',
				'appIdentity',
				'app',
				'appAuthorizationStatus',
				'roles',
				'user'
			])
		},
		methods: {
			auth() {
				if (['initst', 'tesla'].indexOf(this.app.strategy) > -1) {
					this.$modal.show('auth-app');
				} else {
					// passport strategy
					this.$store.dispatch('START_APP_AUTH_REDIRECT', { itemId: this.selectedItem.id });
				}
			},
			onCloseInstallShelf: function() {
				this.shelfComponent = null;
				this.shelfProps = null;
			},
			openInstallShelf: function() {
				this.shelfComponent = ItemInstall;
				this.shelfProps = {};
			},
			toggleInstallShelf: function() {
				if (this.shelfComponent) {
					this.onCloseInstallShelf();
				} else {
					this.openInstallShelf();
				}
			},
		},
		created() {
			this.$store.dispatch('ITEM_DETAILS_REQUEST', { itemId: this.$route.params.itemId, includeApp: true, includeAppIdentity: true });
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.cronReadable{
		text-transform: lowercase;
	}
	.layout-3-col-wrapper {
		display:flex;
		flex: 1 1 auto;
	}

	.left, .right{
		flex-basis:  0;
	}
	.middle{
		max-width: 900px;
		flex-basis: 100%;
	}


	.section-description{
		line-height: 1.5;
	}
	/* .loading{
		margin-top: 150px;
	} */



	.middle{
		/* flex: 1 1 auto; */
		padding-top:40px;

	}

	.arrow-link{
		margin-bottom: 15px;
		display:inline-block;
	}
	.arrow-link i,
	.arrow-link span{
		vertical-align: middle;
	}

	.header-title{
		font-size:24px;
		margin-left:15px;
		display:flex;
		flex-direction: column;
		justify-content: space-between;
		height:80px;
	}
	header{
		display:flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		margin-top:15px;
		margin-bottom:5px;
	}
	header h1{
		flex-grow: 1;
		margin-left:10px;
	}
	header .item-logo{
		height: auto;
		width: 80px;
		height: 80px;
		display:flex;
		background-color: #f1f3f6;
		box-shadow: 5px 5px 10px 0 rgba(61,66,67,0.05);
		text-align:center;
		border: .66px solid white;
	}

	h3{
		font-weight:300;
	}



	/* // Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
	.hidden-sm{
		display:none;
	}
	.middle{
		width:100%;
		flex-basis:100%;
	}
	.right{
		flex-basis:100%;
		padding-bottom: 20px;
		/* height:100%; */
		min-width:350px;
	}
	.right:empty{
		flex-basis:0;
		padding-bottom: 0;
		min-width:0;

	}

	.configuration-panel{
		margin-left: 0;
	}

	.left{
		flex-basis: 0;
	}
	.details-content{
		padding:0 15px 15px;
	}



  }

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
	.hidden-sm{
		display:none;
	}

	.details-content{
		padding:0 15px 15px;

	}
	.middle{
		width:100%;
		flex-basis:100%;
	}

	/* .layout-3-col-wrapper{
		flex-direction: column-reverse;
	} */
	.right{
		flex-basis:100%;
		padding-bottom: 20px;
	}
	.right:empty{
		flex-basis:0;
		padding-bottom: 0;

	}
	.configuration-panel{
		margin-left: 0;
	}
	.left{
		flex-basis: 0;
	}


}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
	.visible-xs, .visible-sm{
		display:none;
	}
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
	.visible-xs, .visible-sm{
		display:none;
	}
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
	.visible-xs, .visible-sm{
		display:none;
	}

}

.header-title .credits {
	font-size: 12px; color: #444;
}
</style>



// WEBPACK FOOTER //
// src/views/MarketplaceItem.vue